// extracted by mini-css-extract-plugin
module.exports = {"no-consents":"NoConsents-module__no-consents___UoRyn","noConsents":"NoConsents-module__no-consents___UoRyn"};